module.exports = __webpack_public_path__ + "media/images/covers/sw-thumb-03-3ee276f9488eccb79dcb1eb70eea4d2c.jpg";